const Pattern = /<\s?img[^>]*>/gi; //img的正则
const srcReg = /src=[\\'\\"]?([^\\'\\"]*)[\\'\\"]?/i; //img里的src正则
export default function changeImgSrc(content, href) {
  // console.log(2333);
  return content.replace(Pattern, function(word) {
    // console.log(word.match(srcReg));
    const imgSrc = word.match(srcReg)[1];
    // 包含绝对路径的图片不处理
    // 的是resource/xxx.png 有的是/resource/xxx.png
    if (imgSrc.indexOf("http") !== -1) {
      return word;
    }
    // base64的图片不处理
    if (imgSrc.indexOf("data:image") !== -1) {
      return word;
    }
    // /resource/xxx.png 的情况 网页的域名/resource/xxx.png
    if (imgSrc.indexOf("/") === 0) {
      let theSlashIndex = href.indexOf("/", 8);
      let rootUrl = href.substring(0, theSlashIndex);
      return word.replace(imgSrc, `${rootUrl}/${imgSrc}`);
    } else {
      let theSlashIndex = href.lastIndexOf("/");
      let rootUrl = href.substring(0, theSlashIndex);
      console.log(rootUrl);
      return word.replace(imgSrc, `${rootUrl}/${imgSrc}`);
    }
    // return word.replace(imgSrc,`${href}/${imgSrc}`);
  });
}
